<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg7>
            <v-card pa-0>
              <v-toolbar card color="white">
                <v-dialog v-model="filterShow" scrollable max-width="300px">
                  <v-btn slot="activator" icon><v-icon>filter_list</v-icon></v-btn>
                  <v-card>
                    <v-card-title>Select Filter</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="height: 300px;">

                    </v-card-text>
                    <v-divider></v-divider>              
                  </v-card>
                </v-dialog>              

                <v-text-field
                flat
                solo
                append-icon="search"
                placeholder="Type something"
                v-model="search.name"
                hide-details              
                ></v-text-field>     
                <!---->
                <router-link :to="{path: formPath}">
                    <v-btn color="success" fab small dark>
                      <v-icon>add</v-icon>
                    </v-btn>  
                </router-link>              
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text class="pa-0">
                <v-data-table                
                  :headers="complex.headers"               
                  :items="complex.items"
                  :loading="loading"
                  :pagination.sync="pagination"
                  :rows-per-page-items="[{text:'All','value':-1}]"
                  hide-actions                
                  item-key="id"                               
                  v-model="complex.selected"
                  >
                  <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td @click="dapilRoute(props.item.id)" class="cursor">{{ no+props.index+1 }}</td>                    
                      <td @click="dapilRoute(props.item.id)" class="cursor">{{ props.item.name }}</td>                    
                      <td @click="dapilRoute(props.item.id)" class="cursor">{{ nameTingkat(props.item.tingkat)  }}</td>  
                      <td @click="dapilRoute(props.item.id)" class="cursor">{{ props.item.area_id }}</td>                  
                      <td class="text-xs-right">
                        <router-link :to="{path:formPath, query: {id: props.item.id}}">
                            <v-btn depressed icon class="primary--text" small>
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </router-link>                                          
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-text>
                <v-chip v-if="length" outline color="primary" style="float:left">Result &nbsp;<strong> {{count}}</strong></v-chip>                 
                <div v-if="length" class="text-xs-right">
                  <v-pagination
                    v-model="page"
                    v-bind:length="length"
                    v-bind:total-visible="5"
                    circle
                  ></v-pagination>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>   
          <v-flex lg5>
            <v-card pa-0 v-if="dapil">
              <v-toolbar card>
                  <v-toolbar-title>{{dapil.name}}</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="pa-0">                
                <v-divider></v-divider>                
                <div class="v-table__overflow">
                  <v-data-table
                      :headers="headersDtl"
                      :items="dapil.dapilDtl"
                      :loading="dapilloading"
                      hide-actions
                      class="elevation-1"                         
                  >                                
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>                             
                    <template slot="items" slot-scope="props" >                      
                      <td>{{props.index+1}}</td>
                      <td>                       
                        <span class="results-as-you-type">
                          {{nameTingkat(props.item.tingkat)}} 
                        </span>
                        <!--<v-autocomplete
                            v-bind:items="tingkats"
                            v:filter="customFilter"                                        
                            item-text="name"
                            item-value="id"
                            v-model="props.item.coa_id"                                        
                            v-if="props.item.magic" 
                            @keyup.ctrl.up="keyup('up', 'coa', (props.index-1))"
                            @keyup.ctrl.down="keyup('down', 'coa', (props.index+1))"                                        
                            @keyup.enter="keyup('enter', 'deb', (props.index))"
                            @keyup.ctrl.enter="submitData"
                            :ref="'coa'+props.index"
                        ></v-autocomplete>-->                          
                      </td>
                      <td>                        
                        <span class="results-as-you-type">
                          {{ props.item.areaName }} 
                        </span>
                      </td>                           
                    </template>
                  </v-data-table> 
                </div>
              </v-card-text>
            </v-card>
            
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/frc/models/Dapil';    
var model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        no : 1,
        page     : 1,
        length   : 0,
        count    : 0,
        pagesize : 10,
        formPath : '/adm/dapil/form',
        search   : {
          name : null,
          
        },
        filterShow : false,
        loading  : true,
        pagination: {},
        complex  : {
            selected: [],
            headers: [              
              { text: 'No',   value: 'id'  },
              { text: 'Name', value: 'name'},
              { text: 'Tingkat', value: 'tingkat'},
              { text: 'Area', value: 'area_id'},
              { text: 'Action', value: '', align:'right' },              
            ],
            items: []
        },
        headersDtl:[
          {text:'No', value:'no'},
          {text:'Tingkat', value:'tingkat'},
          {text:'Area ID', value:'area_id'},          
        ], 
        tingkats : [],
        dapilloading:false,
    }),  
    watch:{
        page(val){
          this.reload();
        },
        search:{
          handler(val, oldVal){                         
            this.reload();
          },
          deep:true        
        },
        pagination(newVal){          
          this.reload();         
        }
    },    
    asyncComputed:{
      dapil(){
        if(this.$route.query.id){
          this.dapilloading = true;
          return model.one({id : this.$route.query.id }).then(data => { 
            this.dapilloading = false;
            return data;            
          });                                               
        }          
      }
    },
    mounted(){ this.init() },        
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.complex.items = data }) },{ deep: true }
            );                                     
        }
        /*this.$watch(['search','date_fr'].join('.'), (val)=>{ if(val){
            this.$refs.date_fr.save(val);
            this.search.dateFr = this.$moment(val).format('DD-MM-YYYY');
        }});        
        this.$watch(['search','dateFr'].join('.'), (val)=>{ if(!val){
            this.search.dateFr = null; this.search.date_fr = null;
        }});*/
        
        this.setTingkats();
    },
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        init(){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }
            
            this.reload();                                                  
        },
                
        reload(){     
            this.loading = true;
            let sortby = this.pagination.descending ? '-'+this.pagination.sortBy : this.pagination.sortBy;                    
            model.all({page:this.page, 'DapilSearch[name]':this.search.name, sort:sortby,            
                //'TransferSearch[date_fr]':this.search.date_fr,                
            }).then(data => {      
                this.complex.items = data.data; 
                this.count   = data.count;
                this.length  = Math.ceil(this.count/this.pagesize);
                this.loading = false;
                this.no      = ((this.page - 1)*10);
            }); 
        },
        
        setTingkats(){
          model.tingkats().then(res=>{
            this.tingkats = res;
          })
        },
        
        nameTingkat(id){
          var result = '';
          this.tingkats.forEach(item=>{if(id === item.id){result = item.name}});
          return result;
        },
        
        dapilRoute (id) {
            this.$router.push({path:'/adm/dapil', query: {id: id}});
        },
    }
}
</script>